var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "partially-denied--container" },
    [
      _c("JadeBox", { attrs: { hasPadding: "" } }, [
        _c("div", { staticClass: "box1--container" }, [
          _c(
            "div",
            { staticClass: "box1__text--container" },
            [
              _c(
                "jade-text",
                { attrs: { weight: "semibold", variant: "heading-medium" } },
                [_vm._v(" " + _vm._s(_vm.$t("box1.title")) + " ")]
              ),
              _c("jade-text", { attrs: { variant: "text-medium" } }, [
                _vm._v(" " + _vm._s(_vm.$t("box1.subtitle")) + " "),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "box1__img--container" }, [
            _c("img", {
              attrs: {
                src: require(`@/assets/kyc/step_qr_code_1.svg`).default,
              },
            }),
          ]),
        ]),
      ]),
      _c("JadeBox", [
        _c("div", { staticClass: "py-5 pr-5" }, [
          _c(
            "div",
            { staticClass: "pl-5" },
            [
              _c(
                "jade-text",
                {
                  staticClass: "qrcode--hide",
                  attrs: { weight: "semibold", variant: "heading-xsmall" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("box2.title")) + " ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "box2--container" }, [
            _c(
              "div",
              { staticClass: "box2-inner" },
              [
                _c(
                  "div",
                  { staticClass: "box2__list--container" },
                  [
                    _c(
                      "div",
                      { staticClass: "pl-5" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: {
                              variant: "overline",
                              color: _vm.COLOR_ENUM.MEDIUM,
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("box2.subtitle")) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c("jade-list-item", {
                      attrs: { label: _vm.$t("box2.list-item-1") },
                      scopedSlots: _vm._u([
                        {
                          key: "leading",
                          fn: function () {
                            return [
                              _c("jade-icon-shape", {
                                attrs: {
                                  use: "camera",
                                  size: _vm.SIZE_ENUM.SMALL,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c("jade-list-item", {
                      attrs: { label: _vm.$t("box2.list-item-2") },
                      scopedSlots: _vm._u([
                        {
                          key: "leading",
                          fn: function () {
                            return [
                              _c("jade-icon-shape", {
                                attrs: {
                                  use: "person-check",
                                  size: _vm.SIZE_ENUM.SMALL,
                                  variant: "brand",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c("jade-list-item", {
                      attrs: { label: _vm.$t("box2.list-item-3") },
                      scopedSlots: _vm._u([
                        {
                          key: "leading",
                          fn: function () {
                            return [
                              _c("jade-icon-shape", {
                                attrs: {
                                  use: "file-folded",
                                  size: _vm.SIZE_ENUM.SMALL,
                                  variant: "brand",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("qr-code-kyc", { on: { qrCodeExpired: _vm.qrCodeExpired } }),
              ],
              1
            ),
            _c("div", { staticClass: "divider" }, [_c("span", [_vm._v("OU")])]),
            _c(
              "div",
              { staticClass: "outside--container" },
              [
                _vm.checkKycStatusEnable
                  ? _c(
                      "jade-button",
                      {
                        staticClass: "outside__button--container",
                        attrs: {
                          loading: _vm.loadingKyc,
                          size: _vm.SIZE_ENUM.MEDIUM,
                          variant: "primary-solid",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("updateKycStatus")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("outside.button")) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "jade-button",
                  {
                    staticClass: "outside__button--container",
                    attrs: {
                      size: _vm.SIZE_ENUM.MEDIUM,
                      variant: "neutral-subtle",
                    },
                    on: { click: _vm.redirectToKycExternal },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("outside.text")) + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "outside__mobile--container" },
              [
                _c(
                  "jade-button",
                  {
                    staticClass: "outside__button--container",
                    attrs: {
                      size: _vm.SIZE_ENUM.MEDIUM,
                      variant: "primary-solid",
                    },
                    on: { click: _vm.redirectToKycExternal },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("outside.button-mobile")) + " ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }